import { useEffect } from 'react';
import { mainButton, miniApp, secondaryButton } from '@telegram-apps/sdk-react';

const themeParams = {
  mainButton: {
    hasShineEffect: true,
    backgroundColor: '#ff2e91',
    textColor: '#fdfcfa',
    position: 'right',
  },
  secondaryButton: {
    textColor: '#fdfcfa',
    backgroundColor: '#242f3b',
    position: 'left',
  },
  miniApp: {
    headerColor: '#1e6b89',
    backgroundColor: '#1e6b89',
    bottomBarColor: '#052a33',
  },
};
export const useThemeParams = () => {
  useEffect(() => {
    mainButton.setParams(themeParams.mainButton);
    secondaryButton.setParams(themeParams.secondaryButton);
    miniApp.setHeaderColor(themeParams.miniApp.headerColor);
    miniApp.setBackgroundColor(themeParams.miniApp.backgroundColor);
    miniApp.setBottomBarColor(themeParams.miniApp.bottomBarColor);
  }, []);
};
